// Usage <fai icon="user">
import {
  faUser,
  faUsers,
  faEnvelope,
  faEye,
  faPlus,
  faInfo,
  faAddressBook,
  faCreditCard,
  faDollarSign,
  faTasks,
  faArrowDown,
  faFilter,
  faTrash,
  faCalendarAlt,
  faMapMarkedAlt,
  faSearch,
  faEraser,
  faMailBulk,
  faReply,
  faList,
  faFileContract,
  faFilePdf,
  faFileExport,
  faClipboardCheck,
  faTimes,
  faHandHoldingUsd,
  faCalculator,
  faDownload
} from '@fortawesome/free-solid-svg-icons'

// Usage <fai :icon="['far', 'file']">
// NOTE: far => font awesome regular
import {
  faFile,
  faFolderOpen,
  faEdit,
  faSave,
  faMoneyBillAlt,
  faCheckSquare,
  faClock
} from '@fortawesome/free-regular-svg-icons'

// import { faBrands } from '@fortawesome/free-brands-svg-icons'

const icons = [
  faUser,
  faUsers,
  faEnvelope,
  faEye,
  faPlus,
  faInfo,
  faArrowDown,
  faAddressBook,
  faCreditCard,
  faDollarSign,
  faTasks,
  faFile,
  faMoneyBillAlt,
  faFilePdf,
  faFileExport,
  faFolderOpen,
  faEdit,
  faTrash,
  faFilter,
  faCalendarAlt,
  faMapMarkedAlt,
  faSearch,
  faEraser,
  faMailBulk,
  faReply,
  faList,
  faFileContract,
  faSave,
  faCheckSquare,
  faClipboardCheck,
  faTimes,
  faHandHoldingUsd,
  faCalculator,
  faDownload,
  faClock
]
export default icons



// WEBPACK FOOTER //
// ./src/icons.js